import { Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import SimpleModal from "../../components/shareComponents/modal/SimpleModal";
import { useCallback, useState } from "react";
import PrivacyPolicy from "../../Layouts/declarationBody/PrivacyPolicy";
import Termsconditions from "../../Layouts/declarationBody/Termsconditions";
import Disclaimer from "../../Layouts/declarationBody/Disclaimer";

const initState = {
  disclaimer: false,
  termsNCond: false,
  privcyNotice: false,
} as const;

const DisclaimerPage = () => {
  const { t } = useTranslation();
  const NUM_100 = 100;
  const [modalState, setModalState] = useState(initState);

  const closeModal = useCallback(() => {
    setModalState(initState);
  }, []);

  const openModal = useCallback((state: keyof typeof initState) => {
    setModalState((val) => ({
      ...val,
      [state]: true,
    }));
  }, []);

  const openPrivatePolicy = useCallback(() => {
    closeModal();
    setTimeout(() => {
      openModal("privcyNotice");
    }, NUM_100);
  }, [closeModal, openModal]);

  return (
    <Grid
      container
      sx={{
        backgroundColor: "background.paper",
        boxShadow: 3,
        my: 5,
        p: 2,
      }}
    >
      <SimpleModal
        header={
          (() => {
            if (modalState.disclaimer) {
              return t("policyText.disclaimer.title");
            } else if (modalState.termsNCond) {
              return t("policyText.termsconditions.mainTitle");
            } else if (modalState.privcyNotice) {
              return t("policyText.privacypolicy.mainTitle");
            } else {
              return "";
            }
          })()
        }
        body={
          (() => {
            if (modalState.disclaimer) {
              return <Disclaimer />;
            } else if (modalState.termsNCond) {
              return (
                <Termsconditions
                  closeCurrentModalOpenPrivatePolicy={openPrivatePolicy}
                />
              );
            } else if (modalState.privcyNotice) {
              return <PrivacyPolicy />;
            } else {
              return "";
            }
          })()
        }
        open={
          modalState.disclaimer ||
          modalState.termsNCond ||
          modalState.privcyNotice
        }
        handleClose={closeModal}
      />
      <Grid container flexDirection="row" alignItems="center">
        <Typography variant="subtitle1">
          <span
            role="button"
            tabIndex={0}
            onClick={() => openModal("disclaimer")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openModal("disclaimer");
              }
            }}
            aria-controls="disclaimer-modal"
            aria-haspopup="dialog"
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: "bold",
              outline: "none"
            }}
          >
            Disclaimer
          </span>

          &nbsp;&nbsp;
          <span
            role="button"
            tabIndex={0}
            onClick={() => openModal("termsNCond")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openModal("termsNCond");
              }
            }}
            aria-controls="termsNCond-modal" // id of the modal (optional but recommended)
            aria-haspopup="dialog"           // indicates that this opens a dialog/modal
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: "bold",
              outline: "none",
            }}
          >
            Terms and Conditions
          </span>
          &nbsp;&nbsp;
          <span
            role="button"
            tabIndex={0}
            onClick={() => openModal("privcyNotice")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openModal("privcyNotice");
              }
            }}
            aria-haspopup="dialog"
            aria-controls="privacyNotice-modal" // optional, if your modal has an ID
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: "bold",
              outline: "none",
              marginRight: "8px",
            }}
          >
            Privacy Notice
          </span>{" "}
          If you have a suspected side effect or problem to report
          regarding one of our products, please contact or send the information
          to the Roche Patient Safety team via: (a) Email:
          hong_kong.drug_safety@roche.com, or (b) Phone: +852 2733 4711.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default DisclaimerPage;
